import { render, staticRenderFns } from "./EditComplaintTypeModal.vue?vue&type=template&id=c0172148&scoped=true"
import script from "./EditComplaintTypeModal.vue?vue&type=script&lang=js"
export * from "./EditComplaintTypeModal.vue?vue&type=script&lang=js"
import style0 from "./EditComplaintTypeModal.vue?vue&type=style&index=0&id=c0172148&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0172148",
  null
  
)

export default component.exports